import {initializeErrorReporting, reportHandledError} from './app/cbet/service/error-reporting.service';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

initializeErrorReporting();

if (environment.production) {
  enableProdMode();
}

enableProdMode();
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => { reportHandledError(err, 'angular.bootstrap'); console.error(err); });
